export {
   MenuItem,
   Dropdown,
   DropdownSubmenu,
   renderGrouped,
   icons,
   joinUpItem,
   liftItem,
   selectParentNodeItem,
   undoItem,
   redoItem,
   wrapItem,
   blockTypeItem,
} from './menu';
export { menuBar } from './menubar';

// !! This module defines a number of building blocks for ProseMirror
// menus, along with a [menu bar](#menu.menuBar) implementation.

// MenuElement:: interface
// The types defined in this module aren't the only thing you can
// display in your menu. Anything that conforms to this interface can
// be put into a menu structure.
//
//   render:: (pm: EditorView) → {dom: dom.Node, update: (EditorState) → bool}
//   Render the element for display in the menu. Must return a DOM
//   element and a function that can be used to update the element to
//   a new state. The `update` function will return false if the
//   update hid the entire element.
